








import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Jumbotron extends Vue {
  private swiperOption = {
    autoplay: 3000,
    autoHeight: true,
    loop: true,
    paginationClickable: true,
    pagination: '.swiper-pagination',
  };
  private urls = require('@/data.json').home.jumbotrons;
}
